import React from "react";
import ReactDOM from "react-dom";
import "webrtc-adapter";
import App from "./App";
import "./index.css";
import("tw-elements");
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
